import { render, staticRenderFns } from "./DefectsTable.vue?vue&type=template&id=08860a9c&scoped=true&"
import script from "./DefectsTable.vue?vue&type=script&lang=ts&"
export * from "./DefectsTable.vue?vue&type=script&lang=ts&"
import style0 from "./DefectsTable.vue?vue&type=style&index=0&id=08860a9c&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "08860a9c",
  null
  
)

export default component.exports